import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import {
  IPartnerAccess,
  IPartnerAccessInfo,
} from "app/models/partners/partners";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  }),
  withCredentials: true,
};

@Injectable({
  providedIn: "root",
})
export class PartnerService {
  lubgwmaPlumber = "LUBGWMA Plumber";
                    
  accessTypes = [this.lubgwmaPlumber];
  passKey = "";
  accessGuid = "";
  defaultDisclaimer = ` 
  By accessing and using this data, you agree to the following terms and conditions:

  1. You agree to use the data in compliance with all applicable laws and regulations.
  2. You will not share, distribute, or sell the data to any third parties.

  Please agree to proceed.
  `;

  constructor(private http?: HttpClient) { 
  }

  removePartner(id: number): Observable<any> {
    return this.http.get(
      environment.privateApi + "PartnersAdmin/Delete/" + id,
      httpOptions
    );
  }

  getPartner(id: number): Observable<IPartnerAccess> {
    return this.http.get<IPartnerAccess>(
      environment.privateApi + "PartnersAdmin/GetPartnerAccess/" + id,
      { withCredentials: true }
    );
  }

  getAll(): Observable<IPartnerAccess[]> {
    return this.http.get<IPartnerAccess[]>(
      environment.privateApi + "PartnersAdmin/All/",
      {
        withCredentials: true,
      }
    );
  }

  savePartner(partner: IPartnerAccess): Observable<any> {
    return this.http.post<any>(
      environment.privateApi + "PartnersAdmin/SavePartner",
      partner,
      httpOptions
    );
  }

  getPartnerTreatments(id: number): Observable<any> {
    return this.http.post<any>(
      environment.publicApi + "Partners/lubgwma/plumbers/treatments/" + id,
      id,
      this.getHttpOptionsForPartners()
    );
  }

  savePartnerTreatment(treatment: any): Observable<any> {
    return this.http.post<any>(
      environment.publicApi + "Partners/lubgwma/plumbers/treatment/save",
      treatment,
      this.getHttpOptionsForPartners()
    );
  }

  getPartnerAccessInfo(guid: string): Observable<IPartnerAccessInfo> {
    return this.http.get<IPartnerAccessInfo>(
      environment.publicApi + "Partners/access/" + guid,
      { withCredentials: true }
    );
  }

  validatePartnerAccessInfo(guid: string, passKey: string): Observable<any> {
    return this.http.get<any>(
      environment.publicApi + "Partners/validate/" + guid + "/" + passKey,
      { withCredentials: true }
    );
  }

  lubgwmaPlumbersSearch(searchText: string): Observable<any> {
    return this.http.post<any>(
      environment.publicApi + "Partners/lubgwma/plumbers/search",
      searchText,
      this.getHttpOptionsForPartners()
    );
  }

  private getHttpOptionsForPartners(): any {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        passkey: this.passKey,
        accessguid: this.accessGuid,
      }),
      withCredentials: true,
    };
  }
}
